import { Skeleton } from '@/components/ui/skeleton';
import { useTopNews } from '@/hooks/useNews';
import { NewsItem as NewsItemType } from '@/lib/types';
import React, { useState } from 'react';
import NewsItem from './NewsItem';

interface TopRankedNewsProps {
  onSelectItem: (item: NewsItemType) => void;
  selectedItem: NewsItemType | null;
}

const TopRankedNews: React.FC<TopRankedNewsProps> = ({ onSelectItem, selectedItem }) => {
  const { data: topNews, isLoading, error } = useTopNews();
  const [viewMode, setViewMode] = useState<'top' | 'background'>('top');

  if (error) {
    return (
      <div className="border-b border-terminal">
        <div className="terminal-section-header">
          Top Ranked News
        </div>
        <div className="p-4 text-[#FF4500]">
          Error loading top news: {error instanceof Error ? error.message : 'Unknown error'}
        </div>
      </div>
    );
  }

  return (
    <div className="border-b border-[#1a1a1a]">
      <div className="terminal-section-header flex justify-between items-center">
        <span>Top Ranked News</span>
        <div className="flex space-x-3 text-xs font-normal">
          <button
            type="button"
            aria-pressed={viewMode === 'top'}
            className={`${viewMode === 'top' ? 'text-terminal' : 'text-[#666]'} hover:text-terminal cursor-pointer`}
            onClick={() => setViewMode('top')}
          >
            Top News
          </button>
          <button
            type="button"
            aria-pressed={viewMode === 'background'}
            className={`${viewMode === 'background' ? 'text-terminal' : 'text-[#666]'} hover:text-terminal cursor-pointer`}
            onClick={() => setViewMode('background')}
          >
            Background & Opinion
          </button>
        </div>
      </div>

      <div className="flex flex-col">
        {viewMode === 'background' ? (
          <div className="px-4 py-2 text-[#666] text-xs">
            Background & Opinion view coming soon...
          </div>
        ) : (
          <>
            {isLoading ? (
              // Show skeletons while loading
              Array(3).fill(0).map((_, i) => (
                <div key={i} className="news-item">
                  <div className="news-id">{i + 1})</div>
                  <Skeleton className="h-3.5 w-full bg-gray-800" />
                  <div className="news-provider">
                    <Skeleton className="h-3.5 w-10 bg-gray-800" />
                  </div>
                  <div className="news-time">
                    <Skeleton className="h-3.5 w-10 bg-gray-800" />
                  </div>
                </div>
              ))
            ) : (
              topNews?.map((item, index) => (
                <NewsItem
                  key={item.id}
                  item={item}
                  index={index + 1}
                  isSelected={selectedItem?.id === item.id}
                  onClick={onSelectItem}
                />
              ))
            )}

            {topNews?.length === 0 && !isLoading && (
              <div className="px-4 py-2 text-terminal">
                No top news available at this time.
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default TopRankedNews;
